import { render, staticRenderFns } from "./aWorkDetailFile.vue?vue&type=template&id=8f5a41c4&scoped=true"
import script from "./aWorkDetailFile.vue?vue&type=script&lang=js"
export * from "./aWorkDetailFile.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailFile.vue?vue&type=style&index=0&id=8f5a41c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5a41c4",
  null
  
)

export default component.exports